<template>

    <q-separator v-if="numShop > 1" />
        
    <q-card-section class="q-pb-xs text-center text-bold">Point de Livraison #{{ numShop }}</q-card-section>

    <q-card-section class="text-center">
        <q-item-label>{{ shop.sap ? shop.sap + ' - ' : '' }}{{ shop.label }}</q-item-label>
        <q-item-label><small>({{ shop.business_label }})</small></q-item-label>
    </q-card-section>

    <q-card-section class="text-center q-pb-none">
        <q-item-label v-if="$_.size(shop.emails)">
            <q-btn v-for="(email, k) in shop.emails" :key="k" icon-right="send" :label="email" dense outline square no-caps class="full-width q-mb-md"
                    @click="link('mailto:'+email)" />
        </q-item-label>
        <q-item-label v-if="shop.phone">
            <q-btn icon-right="phone" :label="shop.phone" dense outline square no-caps
                    @click="link('tel:'+shop.phone)" />
        </q-item-label>
        <q-item-label>{{ shop.address }}</q-item-label>
    </q-card-section>

    <!-- <q-separator /> -->
    <q-card-actions align="center" v-if="isCarrier">
        <q-btn icon="visibility" @click="link(route('shop.edit', shop.id))" dense square outline color="info" />
    </q-card-actions>
        
</template>

<script setup>
import { link,/* hasRole, formatDate, open, nl2br , clickForDownload, rolesToString */ } from "@helpers";
// import { ref, computed } from "@vue/reactivity";
// import { userStore } from "@stores";

const props = defineProps({
    'num-shop': Number,
    shop: Object,
})

// const user_state = userStore().$state

// let isClient = computed(()=> hasRole(props.roles, 'client'))

</script>
